import { LoadableAfterPaint } from '@confluence/loadable';
export { ContentTreeIcon } from '../src/ContentTreeIcon.tsx';

export const ContentTreeIconLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTreeIcon" */ '../src/ContentTreeIcon.tsx'))
			.ContentTreeIcon,
});
